import {PlayerReduxDispatch, PlayerReduxState} from "../types";
import {EducationSessionErrorReason} from "../../../schema";
import {ResponseTimeoutState} from "../../../types/ResponseTimeoutState";

export default function handleAdaptiveResponseTimeout() {
  return (dispatch: PlayerReduxDispatch, getState: () => PlayerReduxState) => {

    const state = getState();
    // Either the timeout has already expired, or it has not been started
    if (state.responseTimeoutState !== ResponseTimeoutState.STARTED) return;

    // Clear recognizing state and set error
    dispatch({
      type: "update",
      payload: {
        isRecognizing: false,
        lastUserInputResult: {
          ok: false,
          recognizedText: undefined,
          errorState: EducationSessionErrorReason.DAILO_STT_ERROR,
        },
        adaptiveInput: null,
        responseTimeoutState: ResponseTimeoutState.FINISHED
      },
    });

    // Trigger the "notPassed" action to show error to user
    dispatch({
      type: "notPassed",
    });
  };
}
